import type { FC } from 'react';

import type { FormInstance } from '@zen/Components/Form/types';
import { TextArea } from '@zen/DesignSystem';

import type { FormFieldProps } from '../FormField';
import FormField from '../FormField';

interface Field {
  name: string;
  textareaRows: number;
  value: string | number;
}

interface Props extends FormFieldProps {
  disabled?: boolean;
  onChange?: (name: string, value: string) => void;
  onFocus?: () => void;
  readOnly?: boolean;
  textareaRows?: number;
}

const FormTextarea: FC<Props> = (props) => (
  <FormField {...props}>
    {(field: Field, form: FormInstance<unknown>) => {
      const { textareaRows, ...rest } = field;

      const handleOnChange = (value: string) => {
        form.setFieldValue(field.name, value);

        if (props.onChange) {
          props.onChange(field.name, value);
        }
      };

      return (
        <TextArea
          {...rest}
          onBlur={form.handleBlur}
          onChange={(event) => handleOnChange(event.target.value)}
          rows={props.textareaRows}
        />
      );
    }}
  </FormField>
);

export default FormTextarea;
